module.exports = __webpack_public_path__ + "media/images/logo_inverted-3b508ed6b33b709f9c9e24450e6fb63a.png";